import Certificate from 'Assets/images/pages/web-chat/certificate.svg';
import MemoImage from 'Assets/images/pages/web-chat/memo_icon.svg';
import Money from 'Assets/images/pages/web-chat/money.svg';
import Prescription from 'Assets/images/pages/web-chat/pill.svg';
import ReferralMemoImage from 'Assets/images/pages/web-chat/referral-memo.svg';
import { bool, func } from 'prop-types';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { MALAYSIA_ISO_CODE } from 'Constants/commons';

import OptionItem from './OptionItem';

const ListMenuBubbleChat = props => {
  const {
    openPOS,
    isFollowUp,
    isGoingConsult,
    openMemoRandum,
    openPrescriptionModal,
    openMedicalCertificate,
    openReferralMemo,
  } = props;

  const doctor = useSelector(state => state.doctors.profile, shallowEqual);
  const practiseCountryCode = doctor?.practiseCountry?.iso;

  // Hide if doctor practise country is Malaysia
  const hideIssueMcFeature = practiseCountryCode === MALAYSIA_ISO_CODE;

  const issueMedicalCertificate = () => {
    openMedicalCertificate(null);
  };

  return (
    <div className="options">
      {isGoingConsult && (
        <>
          {!hideIssueMcFeature && (
            <OptionItem
              icon={Certificate}
              content="Create Medical Certificate"
              onClickItem={issueMedicalCertificate}
            />
          )}
          {!isFollowUp && (
            <OptionItem
              onClickItem={openPrescriptionModal}
              icon={Prescription}
              content="Issue Prescription"
            />
          )}
          <OptionItem icon={MemoImage} onClickItem={openMemoRandum} content="Create Memo" />
          <OptionItem
            icon={ReferralMemoImage}
            onClickItem={openReferralMemo}
            content="Create Referral Letter"
          />
          <OptionItem icon={Money} onClickItem={openPOS} content="Point of Sale" />
        </>
      )}
    </div>
  );
};

ListMenuBubbleChat.propTypes = {
  openPOS: func.isRequired,
  isFollowUp: bool.isRequired,
  isGoingConsult: bool.isRequired,
  openMemoRandum: func.isRequired,
  openPrescriptionModal: func.isRequired,
  openMedicalCertificate: func.isRequired,
  openReferralMemo: func.isRequired,
};

ListMenuBubbleChat.defaultProps = {};

export default ListMenuBubbleChat;
